import {addMinutes, differenceInMinutes, format, subMinutes} from "date-fns";
import {utcToZonedTime} from "date-fns-tz";
import {brazilianTimeZoneCurrentDate, timeZone} from "global/constants";
import {AgencyingSituation} from "util/globalEnums";

const EDIT_LOCK_PERIOD_MINUTES = 5;
const FALLBACK_CREATION_TIME_MINUTES = 10;
const CREATION_DATE_FORMAT = "dd/MM/yyyy, HH:mm";

const shouldDisableVoyageEditByCreatedAtTime = (createdAtValue: string) => {
  const fallbackDate = subMinutes(
    brazilianTimeZoneCurrentDate,
    FALLBACK_CREATION_TIME_MINUTES,
  );

  const createdAt = createdAtValue === "" ? fallbackDate : createdAtValue;

  const createdAtInTimezone = utcToZonedTime(new Date(createdAt), timeZone);

  const minutesSinceCreation = differenceInMinutes(
    brazilianTimeZoneCurrentDate,
    createdAtInTimezone,
  );

  if (minutesSinceCreation > EDIT_LOCK_PERIOD_MINUTES) {
    return false;
  } else {
    return true;
  }
};

const shouldDisableVoyageIfProcessIsCancelled = (
  agencyingSituation: string | null,
) => {
  return agencyingSituation === AgencyingSituation.Cancelado;
};

const getFormattedCreatedAt = (createdAtValue: string | null) => {
  /**
   * Seis minutos para cobrir os segundos que não são exibidos ao usuário.
   */
  const CREATION_TIME_DISPLAY_OFFSET_MINUTES = EDIT_LOCK_PERIOD_MINUTES + 1;

  const creationDate = createdAtValue
    ? new Date(createdAtValue)
    : brazilianTimeZoneCurrentDate;

  const displayDate = addMinutes(
    creationDate,
    CREATION_TIME_DISPLAY_OFFSET_MINUTES,
  );

  const formatted = format(displayDate, CREATION_DATE_FORMAT);
  return formatted;
};

export {
  shouldDisableVoyageEditByCreatedAtTime,
  shouldDisableVoyageIfProcessIsCancelled,
  getFormattedCreatedAt,
};
